<template>
  <div v-if="images.length">
    <div class="d-flex flex-wrap mt-4" v-if="!display.mobile && images.length < 3">
      <div v-for="(image, index) in images"
            :key="`image-${index}`"
            style="width: 150px; height: 150px;"
            class="position-relative ma-2">
        <v-img :src="getImageUrl(image)"
                max-height="150"
                max-width="150"
                class="rounded-lg"
                alt="Uploaded Image Preview"></v-img>
        <v-btn v-if="deletable" icon
                size="x-small"
                color="red"
                class="position-absolute top-0 right-0"
                @click="removeImage(index)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-else
          class="mt-4">
      <v-carousel  hide-delimiters>
        <v-carousel-item v-for="(image, index) in images"
                          :key="`carousel-${index}`"
                          :src="getImageUrl(image)" cover>
          <div
               class="position-relative ma-2 w-100 h-100">
            <v-btn v-if="deletable" icon
                   :size="display.mobile ? 'x-small' : 'large'"
                   color="red"
                   class="position-absolute top-0 right-0 mr-2"
                   @click="removeImage(index)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { useDisplay } from 'vuetify';
const display = ref(useDisplay());
defineProps({
  images: {
    type: Array as PropType<File[]>,
    required: true
  },
  deletable: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['removeImage']);

function removeImage(index: number) {
  emit('removeImage', index);
}

function getImageUrl(image: File | string): string {
  if (image instanceof File) {
    return URL.createObjectURL(image);
  } else if (typeof image === 'string' && image.startsWith('blob:')) {
    return image; // If the image is already a valid blob URL
  } else if (typeof image === 'string') {
    return image; // If the image is a valid URL string
  }
  console.error('Invalid image type:', image);
  return '';
}
</script>

<style>

</style>